import { Box, Button, CircularProgress, Grid, Paper, TextField } from '@mui/material';
import { useRef, useState } from 'react';

import { useNavigate } from 'react-router-dom';

import { PostCompany } from '../services/httpServices';

const CreateCompany = (props) => {
  const navigate = useNavigate();

  const [open, setOpen] = useState(false);

  const [loading, setLoading] = useState(false);
  const [clicked, setClicked] = useState(false);

  const companyLegalNameRef = useRef('');

  const companyGSTNumberRef = useRef('');

  // #endregion Refs

  //   const handleClose = () => {
  //     setOpen(false);
  //   };

  const SaveUser = async (event) => {
    // setPosting(true);
    setLoading(true);
    setClicked(true);
    event.preventDefault();
    //console.log('saveHit');
    const payload = {
      companyName: companyLegalNameRef.current.value,
      companyGst: companyGSTNumberRef.current.value,
    };

    //console.log(payload);
    let response = await PostCompany(payload);
    //console.log('PostResponse:', response);

    if (response.status == 200) {
      props.setMessage('Company has been created successfully.');
      props.setSaved(true);
      props.setOpen(true);
      setLoading(false);
      setTimeout(() => {
        navigate(`/app/CompanyTabs/${response.data.id}/${false}`);
      }, 2000);
    } else {
      props.setMessage(response.data);
      props.setSaved(false);
      props.setOpen(true);
      setClicked(false);
      setLoading(false);
      // setPosting(false);
    }
  };
  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <form onSubmit={SaveUser}>
        {loading ? (
          <Grid display="flex" alignItems="center" justifyContent="center" height="40vh" container>
            <CircularProgress size={60} thickness={3} value={100} />
          </Grid>
        ) : (
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <Box component={Paper} p={1}>
                <Grid container spacing={3}>
                  <Grid item xs={12} sm={4} md={4}>
                    <TextField
                      label="Company Operating Name"
                      required
                      variant="outlined"
                      fullWidth
                      size="small"
                      inputRef={companyLegalNameRef}
                    />
                  </Grid>
                  <Grid item xs={12} sm={4} md={4}>
                    <TextField
                      label="Company G.S.T #"
                      variant="outlined"
                      fullWidth
                      size="small"
                      inputRef={companyGSTNumberRef}
                    />
                  </Grid>
                  <Grid item xs={12} sm={4} md={4}></Grid>
                  <Grid item xs={12} sm={4} md={4}>
                    <Button type="submit" disabled={clicked} variant="contained">
                      Save
                    </Button>
                  </Grid>
                </Grid>
              </Box>
            </Grid>
          </Grid>
        )}
      </form>
    </>
  );
};

export default CreateCompany;
